import React, { useMemo } from 'react';

import { ChallengeApplet } from 'models/ChallengeApplet';
import { groupChallengeApplets } from 'helpers/AppletHelpers';
import useRenderSubmissionApplet from 'hooks/useRenderSubmissionApplet';
import { GapContainer } from 'components/applet-custom-props/components';

type SubmissionAppletsProps = {
  applets: ChallengeApplet[];
};

const SubmissionApplets = ({ applets }: SubmissionAppletsProps) => {
  const groupedApplets = useMemo(
    () => groupChallengeApplets(applets),
    [applets],
  );
  const renderApplet = useRenderSubmissionApplet();
  return <GapContainer>
    {groupedApplets.map((applet) => renderApplet(applet))}
  </GapContainer>;
};

export default SubmissionApplets;
